import type { ReactElement, ReactNode } from 'react';

import { CurrencyConnected } from '../../../../../currency/CurrencyConnected';
import { Card, getCardInfo } from '../../../../../game/card/card';
import { L12nText } from '../../../../../text/L12nText';
import stylesHistory from '../../HistoryBetInfo.module.css';

import Charlie6 from './assets/BlackjackOne/6Charlie.png';

import styles from './BlackjackOneTableResult.module.css';

interface IBlackjackHand {
  bet: number;
  card: string[];
  doubledDown: string;
  net: number;
  number: string;
  split: string;
  score: number;
  betbehind: IBlackjackHand;
}

interface IBlackjackHandRaw {
  bet: string;
  card: string[];
  doubledDown: string;
  net: string;
  number: string;
  split: string;
  score: string;
  betbehind: IBlackjackHandRaw;
}

interface IBlackjackSeat {
  name: string;
  dealer: string;
  hand: IBlackjackHandRaw | IBlackjackHandRaw[];
  number: string;
  insurance: number;
  insurancPayOff: number;
}

interface OneBlackjackResultProps {
  seats: IBlackjackSeat[];
  tableClass: string;
}

interface SeatType {
  dealer: string;
  number: number;
  seat: number;
  insurance?: number;
  insurancPayOff?: number;
  name: string;
  hand: IBlackjackHand[];
  rowLength?: number;
}

export default function BlackjackOneTableResult({ seats }: OneBlackjackResultProps): ReactNode {
  if (!seats) {
    return null;
  }

  const bjPlayerData: SeatType[] = [];
  for (let i = 0; i < seats.length; i++) {
    const tempObj: SeatType = {
      dealer: seats[i].dealer,
      number: Number(seats[i].number),
      seat: 7 - Number(seats[i].number),
      name: seats[i].name,
      hand: [],
    };
    if (seats[i].insurance) {
      tempObj.insurance = Number(seats[i].insurance);
    }
    if (seats[i].insurancPayOff) {
      tempObj.insurancPayOff = Number(seats[i].insurancPayOff);
    }
    tempObj.name = seats[i].name;
    tempObj.hand = [];
    if (seats[i].dealer === 'false') {
      const hand = seats[i].hand;
      if (Array.isArray(hand)) {
        for (let s = 0; s < hand.length; s++) {
          if (hand[s].bet) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            hand[s].bet = Number(hand[s].bet);
          }
          if (hand[s].net) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            hand[s].net = Number(hand[s].net);
          }
          if (hand[s].score) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            hand[s].score = Number(hand[s].score);
          }
        }
        tempObj.hand = hand as unknown as IBlackjackHand[];
        tempObj.rowLength = hand.length + 1;
      } else {
        if (hand.bet) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          hand.bet = Number(hand.bet);
        }
        if (hand.net) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          hand.net = Number(hand.net);
        }

        tempObj.hand.push(hand as unknown as IBlackjackHand);
        tempObj.rowLength = 1;

        if (hand.betbehind) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          hand.betbehind.net = Number(hand.betbehind.net);
        }
      }
    }
    bjPlayerData.push(tempObj);
  }
  return (
    <>
      <thead>
        <tr>
          <td className={stylesHistory.table_head}>
            <L12nText tk="BETTYPE" />
          </td>
          <th className={stylesHistory.table_head}>
            <L12nText tk="BET_LABEL" />
          </th>
          <th className={stylesHistory.table_head}>
            <L12nText tk="NETCASH" />
          </th>
        </tr>
      </thead>
      <tbody>
        {bjPlayerData.map((item) => {
          return (
            item.dealer === 'false' && (
              <>
                {item.hand.map((Phand) => {
                  return (
                    <>
                      {Phand.number === '0' && (
                        <>
                          <tr>
                            <td>
                              {item.hand.length >= 1 && (
                                <>
                                  {item.hand[0].split === 'false' && (
                                    <span>
                                      <L12nText tk="MAINBET" />
                                    </span>
                                  )}
                                  {item.hand[0].split === 'true' && (
                                    <span>
                                      <L12nText tk="HAND1" />
                                    </span>
                                  )}
                                </>
                              )}
                            </td>
                            <td>
                              {item.hand.length >= 1 && item.hand[0].doubledDown === 'true' && (
                                <span>
                                  <CurrencyConnected value={Phand.bet} />
                                </span>
                              )}
                              {item.hand.length >= 1 && item.hand[0].doubledDown === 'false' && (
                                <span>
                                  <CurrencyConnected value={Phand.bet} />
                                </span>
                              )}
                            </td>
                            <td style={{ width: '26%', textAlign: 'right' }}>
                              {item.hand.length >= 1 && item.hand[0].doubledDown === 'true' && (
                                <span className={Phand.net > 0 ? stylesHistory.win : stylesHistory.lose}>
                                  <CurrencyConnected value={Phand.net} />
                                </span>
                              )}
                              {item.hand.length >= 1 && item.hand[0].doubledDown === 'false' && (
                                <span className={Phand.net > 0 ? stylesHistory.win : stylesHistory.lose}>
                                  <CurrencyConnected value={Phand.net} />
                                </span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={3}>
                              {item.hand[0].split === 'true' && (
                                <div className={styles.blackjackOneTableResult__score}>
                                  {Phand.card.length == 6 && Phand.score <= 21 && (
                                    <div>
                                      <img src={Charlie6} alt=""></img>
                                    </div>
                                  )}
                                  <div className={styles.blackjackOneTableResult__row}>
                                    {Phand.card.map((card, k) => {
                                      const info = getCardInfo(parseInt(card?.match(/\d+/)?.[0] || '0'));
                                      return <Card key={k} value={info.value} suite={info.suite} />;
                                    })}
                                  </div>
                                  <span className={styles.blackjackOneTableResult__scoreLabel}>{Phand.score}</span>
                                </div>
                              )}
                              {item.hand[0].split === 'false' && (
                                <div className={styles.blackjackOneTableResult__score}>
                                  {Phand.card.length == 6 && Phand.score <= 21 && (
                                    <div>
                                      <img src={Charlie6} alt=""></img>
                                    </div>
                                  )}
                                  <div className={styles.blackjackOneTableResult__row}>
                                    {Phand.card.map((card, k) => {
                                      const info = getCardInfo(parseInt(card?.match(/\d+/)?.[0] || '0'));
                                      return <Card key={k} value={info.value} suite={info.suite} />;
                                    })}
                                  </div>
                                  <span className={styles.blackjackOneTableResult__scoreLabel}>{Phand.score}</span>
                                </div>
                              )}
                            </td>
                          </tr>
                        </>
                      )}
                      {Phand.number == '0' && item.hand.length >= 1 && item.hand[0].doubledDown == 'true' && (
                        <>
                          <tr>
                            <td>
                              <span>
                                <L12nText tk="DOUBLEBET" />
                              </span>
                            </td>
                            <td>
                              <CurrencyConnected value={Phand.bet} />
                            </td>
                            <td>
                              <span className={Phand.net > 0 ? stylesHistory.win : stylesHistory.lose}>
                                <CurrencyConnected value={Phand.net} />
                              </span>
                            </td>
                          </tr>
                        </>
                      )}

                      {Phand.number === '1' && (
                        <>
                          <tr>
                            <td>
                              <span>
                                <L12nText tk="HAND2" />
                              </span>
                            </td>
                            <td>
                              <CurrencyConnected value={Phand.bet} />
                            </td>
                            <td>
                              <span className={Phand.net > 0 ? stylesHistory.win : stylesHistory.lose}>
                                <CurrencyConnected value={Phand.net} />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={3}>
                              <div className={styles.blackjackOneTableResult__score}>
                                {Phand.card.length == 6 && Phand.score <= 21 && (
                                  <div>
                                    <img src={Charlie6} alt=""></img>
                                  </div>
                                )}
                                <div className={styles.blackjackOneTableResult__row}>
                                  {Phand.card.map((card, k) => {
                                    const info = getCardInfo(parseInt(card?.match(/\d+/)?.[0] || '0'));
                                    return <Card key={k} value={info.value} suite={info.suite} />;
                                  })}
                                </div>
                                <span className={styles.blackjackOneTableResult__scoreLabel}>{Phand.score}</span>
                              </div>
                            </td>
                          </tr>
                        </>
                      )}

                      {Phand.number == '2' && (
                        <>
                          <tr>
                            <td>
                              <L12nText tk="21+3" />
                            </td>
                            <td>
                              <CurrencyConnected value={Phand.bet} />
                            </td>
                            <td style={{ width: '26%', textAlign: 'right' }}>
                              <span className={Phand.net > 0 ? stylesHistory.win : stylesHistory.lose}>
                                <CurrencyConnected value={Phand.net} />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={3}>
                              <div className={styles.blackjackOneTableResult__score}>
                                <div className={styles.blackjackOneTableResult__row}>
                                  {Phand.card.map((card, k) => {
                                    const info = getCardInfo(parseInt(card?.match(/\d+/)?.[0] || '0'));
                                    return <Card key={k} value={info.value} suite={info.suite} />;
                                  })}
                                </div>
                                <span className={styles.blackjackOneTableResult__scoreLabel}>{Phand.score}</span>
                              </div>
                            </td>
                          </tr>
                        </>
                      )}
                      {Phand.number == '3' && (
                        <>
                          <tr>
                            <td>
                              <L12nText tk="PERFECT_PAIRS_SIDEBETS" />
                            </td>
                            <td>
                              <CurrencyConnected value={Phand.bet} />
                            </td>
                            <td>
                              <span className={Phand.net > 0 ? stylesHistory.win : stylesHistory.lose}>
                                <CurrencyConnected value={Phand.net} />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={3}>
                              <div className={styles.blackjackOneTableResult__score}>
                                <div className={styles.blackjackOneTableResult__row}>
                                  {Phand.card.map((card, k) => {
                                    const info = getCardInfo(parseInt(card?.match(/\d+/)?.[0] || '0'));
                                    return <Card key={k} value={info.value} suite={info.suite} />;
                                  })}
                                </div>
                                <span className={styles.blackjackOneTableResult__scoreLabel}>{Phand.score}</span>
                              </div>
                            </td>
                          </tr>
                        </>
                      )}
                      {Phand.number == '4' && (
                        <>
                          <tr>
                            <td>
                              <L12nText tk="BUST_BONUS" />
                            </td>
                            <td>
                              <CurrencyConnected value={Phand.bet} />
                            </td>
                            <td>
                              <span className={Phand.net > 0 ? stylesHistory.win : stylesHistory.lose}>
                                <CurrencyConnected value={Phand.net} />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={3}>
                              <div className={styles.blackjackOneTableResult__score}>
                                <div className={styles.blackjackOneTableResult__row}>
                                  {Array.isArray(Phand.card)
                                    ? Phand.card.map((card, k) => {
                                        const info = getCardInfo(parseInt(card?.match(/\d+/)?.[0] || '0'));
                                        return <Card key={k} value={info.value} suite={info.suite} />;
                                      })
                                    : ((): ReactElement => {
                                        const info = getCardInfo(
                                          parseInt((Phand.card as string)?.match(/\d+/)?.[0] || '0')
                                        );
                                        return <Card value={info.value} suite={info.suite} />;
                                      })()}
                                </div>
                                <span className={styles.blackjackOneTableResult__scoreLabel}>{Phand.score}</span>
                              </div>
                            </td>
                          </tr>
                        </>
                      )}
                      {Phand.number == '5' && (
                        <>
                          <tr>
                            <td>
                              <L12nText tk="SUPER_7" />
                            </td>
                            <td>
                              <CurrencyConnected value={Phand.bet} />
                            </td>
                            <td>
                              <span className={Phand.net > 0 ? stylesHistory.win : stylesHistory.lose}>
                                <CurrencyConnected value={Phand.net} />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={3}>
                              <div className={styles.blackjackOneTableResult__score}>
                                <div className={styles.blackjackOneTableResult__row}>
                                  {Phand.card.map((card, k) => {
                                    const info = getCardInfo(parseInt(card?.match(/\d+/)?.[0] || '0'));
                                    return <Card key={k} value={info.value} suite={info.suite} />;
                                  })}
                                </div>
                                <span className={styles.blackjackOneTableResult__scoreLabel}>{Phand.score}</span>
                              </div>
                            </td>
                          </tr>
                        </>
                      )}
                    </>
                  );
                })}
                {item.insurance && item.insurancPayOff && item.insurance > 0 ? (
                  <tr>
                    <td>
                      <L12nText tk="INSURANCE" />
                    </td>
                    <td>
                      <CurrencyConnected value={item.insurance} />
                    </td>
                    <td>
                      <span className={item.insurancPayOff > 0 ? stylesHistory.win : stylesHistory.lose}>
                        <CurrencyConnected value={item.insurancPayOff} />
                      </span>
                    </td>
                  </tr>
                ) : null}
              </>
            )
          );
        })}
      </tbody>
    </>
  );
}
